import { render } from "./MfgCard.vue?vue&type=template&id=227b8ea4"
import script from "./MfgCard.vue?vue&type=script&lang=js"
export * from "./MfgCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__